import AnimationFactory from "../../../../../lib/html5-software-library/src/ranj/ui/animation/AnimationFactory";
import AnimationOptions from "../../../../../lib/html5-software-library/src/ranj/ui/animation/AnimationOptions";
import AbstractCommand from "../../application/AbstractCommand";
import LanguageEvent from "../model/LanguageEvent";
import LanguageModel from "../model/LanguageModel";

export default class SelectLanguageCommand extends AbstractCommand {
    /**
     * @constructor
     * @param {soma.EventDispatcher} dispatcher 
     * @param {LanguageModel} languageModel 
     */
    constructor(dispatcher, languageModel) {
        super(dispatcher);

        this._languageModel = languageModel;;
    }

    execute(evt) {
        const languageCode = evt.params.data.languageCode;
        this._languageModel.currentLanguage = languageCode;

        console.log(`SelectLanguageCommand.execute setting language code to '${languageCode}'`);

        this.dispatch(LanguageEvent.SELECTED);
    }
}